import { styled } from '@mui/material/styles';
import { RobotoFont } from '../../styles/fonts';

export const Form = styled('form')({
  display: 'flex',
  alignItems: 'center',
});

export const Input = styled('input')(({ theme }) => ({
  fontFamily: RobotoFont.style.fontFamily,
  backgroundColor: '#2B2B2B',
  letterSpacing: '2px',
  paddingLeft: '40px',
  border: 'none',
  outline: 'none',
  width: '100%',
  maxWidth: '360px',
  height: '48px',
  color: 'rgba(193, 193, 193, 0.5)',
  fontSize: '16px',
  lineHeight: '20px',
  [theme.breakpoints.down('md768')]: {
    paddingLeft: '20px',
  },
}));

export const Button = styled('button')(({ theme }) => ({
  fontFamily: RobotoFont.style.fontFamily,
  fontSize: '16px',
  lineHeight: '20px',
  backgroundColor: '#393939',
  letterSpacing: '2px',
  color: theme.palette.background.default,
  height: '48px',
  width: '169px',
  border: 'none',
  cursor: 'pointer',
}));
